export const APPLE_STORE_APP_LINK = "https://apps.apple.com/us/app/grups/id6717571965"
export const GOOGLE_PLAY_APP_LINK = "https://play.google.com/store/apps/details?id=ingenia.la.grupsapp"
export const DEFAULT_APP_LINK = "https://www.grups.app/#descarga";